/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as NewRouteImport } from './routes/new'
import { Route as RunsRouteImport } from './routes/runs'
import { Route as RunsIndexRouteImport } from './routes/runs.index'
import { Route as RunsRunIdRouteImport } from './routes/runs.$runId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsRoute = LeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRoute = RunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RunsRoute,
} as any)
const RunsRunIdRoute = RunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => RunsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/new': typeof NewRoute
  '/runs': typeof RunsRouteWithChildren
  '/runs/$runId': typeof RunsRunIdRoute
  '/runs/': typeof RunsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/new': typeof NewRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/runs': typeof RunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/new': typeof NewRoute
  '/runs': typeof RunsRouteWithChildren
  '/runs/$runId': typeof RunsRunIdRoute
  '/runs/': typeof RunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/leads' | '/new' | '/runs' | '/runs/$runId' | '/runs/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/leads' | '/new' | '/runs/$runId' | '/runs'
  id: '__root__' | '/' | '/leads' | '/new' | '/runs' | '/runs/$runId' | '/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LeadsRoute: typeof LeadsRoute
  NewRoute: typeof NewRoute
  RunsRoute: typeof RunsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads': {
      id: '/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof LeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs': {
      id: '/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof RunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/': {
      id: '/runs/'
      path: '/'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof RunsRoute
    }
    '/runs/$runId': {
      id: '/runs/$runId'
      path: '/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof RunsRunIdRouteImport
      parentRoute: typeof RunsRoute
    }
  }
}

interface RunsRouteChildren {
  RunsRunIdRoute: typeof RunsRunIdRoute
  RunsIndexRoute: typeof RunsIndexRoute
}

const RunsRouteChildren: RunsRouteChildren = {
  RunsRunIdRoute: RunsRunIdRoute,
  RunsIndexRoute: RunsIndexRoute,
}

const RunsRouteWithChildren = RunsRoute._addFileChildren(RunsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LeadsRoute: LeadsRoute,
  NewRoute: NewRoute,
  RunsRoute: RunsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
